/* ============================================================
   c_checkout-guard.js
   ────────────────────────────────────────────────────────────
   チェックアウトを止める「理由」を 1 箇所に集約する。

   カート周りには checkout を止めたい機能が複数ある:
     - c_cart-validation : 在庫品/受注品の混在確認・受注品複数の納期確認
     - c_cart-gift       : ギフト包装の手数料数量がカートとずれていたとき

   それぞれが独立に aria-disabled を付け外しすると、片方の解除処理が
   もう片方のブロックを解除してしまう。理由を Set で持ち、
   1 つでも残っていればブロックする形に統一する。

   使い方:
     CCheckoutGuard.block('mixed-cart', onAttempt)  // onAttempt は任意
     CCheckoutGuard.unblock('mixed-cart')
     CCheckoutGuard.isBlocked()

   onAttempt はブロック中に checkout を押されたときに呼ばれる。
   複数の理由がある場合は、先に登録された理由のものだけを呼ぶ。

   PayPal 等の追加決済ボタンは iframe / Web Component で描画され
   click を捕捉できないことがあるため、CSS の pointer-events で
   操作そのものを止める（c_checkout-guard.css）。
   ============================================================ */
(function () {
  'use strict';

  if (window.CCheckoutGuard) return;

  var BLOCKED_CLASS = 'c-checkout-blocked';

  // 通常の checkout ボタン。click/submit を JS で捕捉する対象。
  var CHECKOUT_SELECTOR =
    '[name="checkout"], button[name="checkout"], .cart__checkout-button, #checkout';

  var reasons = new Map();

  function eachButton(fn) {
    document.querySelectorAll(CHECKOUT_SELECTOR).forEach(fn);
  }

  function apply() {
    var blocked = reasons.size > 0;
    document.body.classList.toggle(BLOCKED_CLASS, blocked);
    eachButton(function (btn) {
      if (blocked) {
        btn.setAttribute('aria-disabled', 'true');
        btn.dataset.checkoutBlocked = '1';
      } else {
        btn.removeAttribute('aria-disabled');
        delete btn.dataset.checkoutBlocked;
      }
    });
  }

  function firstHandler() {
    var handler = null;
    reasons.forEach(function (fn) {
      if (handler === null && typeof fn === 'function') handler = fn;
    });
    return handler;
  }

  /**
   * イベントから「押された checkout ボタン」を取り出す。
   * submit イベントの target は <form> であってボタンではないため、
   * submitter を見る必要がある（見られない環境では click 側で捕捉される）。
   */
  function checkoutButtonFrom(e) {
    var origin = e.type === 'submit' ? e.submitter : e.target;
    if (!origin || !origin.closest) return null;
    return origin.closest(CHECKOUT_SELECTOR);
  }

  function onAttempt(e) {
    if (reasons.size === 0) return;
    if (!checkoutButtonFrom(e)) return;
    e.preventDefault();
    e.stopPropagation();
    var handler = firstHandler();
    if (handler) handler();
  }

  document.addEventListener('click', onAttempt, true);
  document.addEventListener('submit', onAttempt, true);

  // cart-drawer などが Ajax でカートを描き替えたら、ボタンの状態を貼り直す
  document.addEventListener('cart:refresh', apply);

  window.CCheckoutGuard = {
    /**
     * @param {string} reason 理由の識別子。同じ理由で複数回呼んでも増えない
     * @param {Function} [handler] ブロック中に checkout を押されたときの挙動
     */
    block: function (reason, handler) {
      if (!reason) return;
      reasons.set(reason, handler || null);
      apply();
    },
    unblock: function (reason) {
      if (!reason) return;
      reasons.delete(reason);
      apply();
    },
    isBlocked: function () {
      return reasons.size > 0;
    },
    has: function (reason) {
      return reasons.has(reason);
    },
    refresh: apply
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
